/**
 * Defense in depth for externally-sourced URLs: only http(s) may become a
 * clickable href / window.open target, so a javascript:/data: URL that slipped
 * past the backend sanitizer — or arrived via a live-stream overlay that never
 * passes through it — can't execute on click. Non-http values render as plain
 * text at the call sites.
 */
export const safeHref = (url?: string | null): string | undefined =>
  url && /^https?:\/\//i.test(url) ? url : undefined;
